// extracted by mini-css-extract-plugin
export default {"review":"review-product_review__7U2Zu","rating":"review-product_rating__xQyFG","button":"review-product_button__OopW6"};